import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { Auth } from '../../services/auth';

@Component({
  selector: 'app-unauthorized',
  imports: [],
  templateUrl: './unauthorized.html',
  styleUrl: './unauthorized.scss'
})
export class Unauthorized {
  constructor(private router: Router, private authService: Auth) {}

  goHome(): void {
    this.router.navigate(['']);
  }

  doLogin(): void {
    if (['prod', 'uat'].includes(environment.name.toLowerCase())) {
      window.location.href = '';
    } else {
      this.authService.initiateLogin();
    }
  }

  doLogout(): void {
    this.authService.initiateLogout();
  }
}
